import { render, staticRenderFns } from "./HorseHistorique.vue?vue&type=template&id=7d4fc18b&"
import script from "./HorseHistorique.vue?vue&type=script&lang=js&"
export * from "./HorseHistorique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports